import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/funktionsuebersicht.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/funktionsuebersicht')({
  component: Content,
});
